<section class="table-content-card">
    <div class="mb-4">
        <h3 class="m-0">الفئات</h3>
        <div class="flex justify-content-end">
            <span class="p-input-icon-left mx-2">
                <i class="pi pi-search"></i>
                <input
                    [formControl]="search"
                    class="w-25rem"
                    pInputText
                    placeholder="البحث عن فئة"
                    type="text" />
            </span>
            <p-button (onClick)='createCategory()' icon="pi pi-plus" label="إضافة فئة"></p-button>
        </div>
    </div>
    <div>
        <p-table
            (rowsChange)="limit = $event"
            [loading]="loading"
            [scrollable]="true"
            [tableStyle]="{ 'max-height': '50vh', 'min-height': tableMinHeight, 'overflow-y': 'auto' }"
            [value]="categories"
            scrollHeight="65vh">

            <ng-template pTemplate="header">
                <tr>
                    <th>الاسم</th>
                    <th>مثبتة؟</th>
                    <th>إجراءات</th> <!-- عمود الإجراءات الجديد -->
                </tr>
            </ng-template>

            <ng-template let-category pTemplate="body">
                <tr>
                    <td>{{ category.name }}</td>
                    <td>
                        <p-button
                            (onClick)="togglePinCategory(category)"
                            [icon]="category.isPinned ? 'pi pi-times' : 'pi pi-thumbtack'"
                            [label]="category.isPinned ? 'إلغاء التثبيت' : 'تثبيت'"
                            [styleClass]="category.isPinned ? 'p-button-secondary' : 'p-button-success'">
                        </p-button>
                    </td>
                    <td>
                        <!-- أزرار التعديل والحذف -->
                        <div class="flex gap-2">
                            <p-button
                                (onClick)="editCategory(category)"
                                icon="pi pi-pencil"
                                pTooltip="تعديل"
                                styleClass="p-button-rounded p-button-text p-button-info">
                            </p-button>

                            <p-button
                                (onClick)="deleteCategory(category, $event)"
                                icon="pi pi-trash"
                                pTooltip="حذف"
                                styleClass="p-button-rounded p-button-text p-button-danger">
                            </p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <div class="empty-message">
                    <app-empty-state></app-empty-state>
                </div>
            </ng-template>

        </p-table>

        <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="0"
            [rowsPerPageOptions]="[10, 20, 30]"
            [rows]="perPage"
            [totalRecords]="total">
        </p-paginator>
    </div>
</section>
<p-confirmPopup></p-confirmPopup>
